import PDAHeader from "src/components/common/Header";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import { usePDA1030_R01Content } from "./PDA1030_R01Content";
import PDA1030_R01Search from "./PDA1030_R01Search";
import PDA1030_R01Table from "./PDA1030_R01Table";
import usePDA1030_R01Store from "./Store_PDA1030_R01";

interface PDA1030_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1030_R01Container = ({
  menuNm,
  menuCd,
  onBack,
}: PDA1030_R01ContainerProps) => {
  const initData = usePDA1030_R01Store((state) => state.initData);
  const { handleMenuClick } = usePDAContainer(initData);
  const {
    startDate,
    endDate,
    isLoading,
    handleStartDateChange,
    handleEndDateChange,
    handleSearch,
  } = usePDA1030_R01Content();

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader
        menuNm={menuNm}
        menuCd={menuCd}
        onBack={onBack}
        onMenuClick={handleMenuClick}
      />

      <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
        <PDA1030_R01Search
          startDate={startDate}
          endDate={endDate}
          isLoading={isLoading}
          onStartDateChange={handleStartDateChange}
          onEndDateChange={handleEndDateChange}
          onSearch={handleSearch}
        />
        <div className="flex-1 min-h-0 overflow-hidden">
          <PDA1030_R01Table />
        </div>
      </div>

      {isLoading && <SpinnerOverlay text="조회 중입니다..." />}
    </div>
  );
};

export default PDA1030_R01Container;
